<template>
    <!-- 右边主体[[ -->
    <router-view></router-view>
    <!-- 右边主体]] -->
</template>
<style lang="scss" scoped>
    @import '~Assets/sass/pages/v4/contribute/task.scss';
</style>
<script>
// 测试代码

// 测试代码
export default {
    data() {
        return {}
    },
    components: {},
    mounted(){
    },
    methods: {}
}
</script>